import { SalamatSubscriptionInfo } from './salamat-subscription-info';

export class SalamatPrescription {
  constructor(
    creationDate: string,
    partnerName: string,
    partnerPhone: string,
    patientFirstName: string,
    patientLastName: string,
    patientGender: string,
    patientMobileNumber: string,
    patientBirthDate: string,
    contractPartyName: string,
    noMedicalSystem: number,
    licenseName: string,
    samadCode: string,
    typeId: number,
    hasInventory: number,
    inventoryMessage: string[],
    subscriptionInfos: SalamatSubscriptionInfo[]
  ) {
    this.creationDate = creationDate;
    this.partnerName = partnerName;
    this.partnerPhone = partnerPhone;
    this.patientFirstName = patientFirstName;
    this.patientLastName = patientLastName;
    this.patientGender = patientGender;
    this.patientMobileNumber = patientMobileNumber;
    this.patientBirthDate = patientBirthDate;
    this.contractPartyName = contractPartyName;
    this.noMedicalSystem = noMedicalSystem;
    this.licenseName = licenseName;
    this.samadCode = samadCode;
    this.typeId = typeId;
    this.hasInventory = hasInventory;
    this.inventoryMessage = inventoryMessage;
    this.subscriptionInfos = subscriptionInfos;
  }

  public creationDate: string;
  public partnerName: string;
  public partnerPhone: string;
  public patientFirstName: string;
  public patientLastName: string;
  public patientGender: string;
  public patientMobileNumber: string;
  public patientBirthDate: string;
  public contractPartyName: string;
  public noMedicalSystem: number;
  public licenseName: string;
  public samadCode: string;
  public typeId: number;
  public hasInventory: number;
  public inventoryMessage: string[];
  public subscriptionInfos: SalamatSubscriptionInfo[];
}

export class checkOtherServices {
  constructor(checkCode: string) {
    this.checkCode = checkCode;
  }
  public checkCode: string;
}

export class uidViewModel {
  constructor(
    cpartySessionId: string,
    citizenSessionId: string,
    nationalCode: string,
    checkCode: string,
    uId: string,
    count: number,
    selectIndex: number
  ) {
    this.cpartySessionId = cpartySessionId;
    this.citizenSessionId = citizenSessionId;
    this.nationalCode = nationalCode;
    this.checkCode = checkCode;
    this.uId = uId;
    this.count = count;
    this.selectIndex = selectIndex;
  }
  public cpartySessionId: string;
  public citizenSessionId: string;
  public nationalCode: string;
  public checkCode: string;
  public uId: string;
  public count: number;
  public selectIndex: number;
}

export class checkCodeViewModel {
  constructor(index: number, id: string, checkCode: string) {
    this.index = index;
    this.id = id;
    this.checkCode = checkCode;
  }
  public index: number;
  public id: string;
  public checkCode: string;
}
